// Kit / quantity selector on the product page and inside quick-add popups.
//
// Delegated from the document on purpose: the popups inject their product
// markup after this script has run, so binding directly to the
// `.pottd-product--kit` elements present at parse time left the cards in those
// popups with no handler at all — they looked unclickable.
(function () {
  // The kits of one product instance are the ones sharing the closest ancestor
  // that holds more than one card. Derived instead of hardcoded so this keeps
  // working wherever the snippet is rendered.
  function kitScope(kit) {
    var node = kit.parentElement;
    while (node && node !== document.body) {
      if (node.querySelectorAll('.pottd-product--kit').length > 1) return node;
      node = node.parentElement;
    }
    return kit.parentElement;
  }

  document.addEventListener('click', function (event) {
    var kit = event.target.closest('.pottd-product--kit');
    if (!kit) return;

    var input = kit.querySelector('input[type="radio"][name="quantity"]');
    if (!input) return;

    // `id="Quantity-<block.id>"` repeats across products built from the same
    // template, so a <label for> can resolve to a duplicate id belonging to
    // another product elsewhere in the document. Drive this kit's radio
    // directly rather than letting the label do it.
    if (event.target.closest('label')) event.preventDefault();

    var scope = kitScope(kit) || document;
    scope.querySelectorAll('.pottd-product--kit--active').forEach(function (activeKit) {
      activeKit.classList.remove('pottd-product--kit--active');
    });
    kit.classList.add('pottd-product--kit--active');

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Same duplicate-id caveat as above: the radio's inline onchange resolves
    // CurrentQuantity-<product.id> with getElementById, which can land on
    // another instance. Set the one in this scope as well.
    var currentQuantity = scope.querySelector('input[name="current_quantity"]');
    if (currentQuantity) currentQuantity.value = input.value;
  });
})();
